if (!customElements.get('collection-display-meta-slider')) {
  class CollectionDisplayMetaSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.collection-display-meta__track');
      this.items = [...this.track.children];

      requestAnimationFrame(() => {
        if (window.innerWidth < 750) this._applyLayout();
      });

      this.resizeObserver = new ResizeObserver(() => {
        if (window.innerWidth >= 750) {
          this._reset();
        } else {
          this._applyLayout();
        }
      });

      this.resizeObserver.observe(this.track);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    _applyLayout() {
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const paddingLeft = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
      const vw = this.track.offsetWidth;
      if (!vw) return;
      const width = Math.floor((vw - paddingLeft - gap) / 1.05);
      this.items.forEach((item) => (item.style.width = `${width}px`));
    }

    _reset() {
      this.items.forEach((item) => (item.style.width = ''));
    }
  }

  customElements.define('collection-display-meta-slider', CollectionDisplayMetaSlider);
}
